import React from 'react';
import { Field } from 'redux-form';
import SettingField from 'components/Fields/ReduxForm/SettingField';

class ItemVariantSalesTypesFields extends React.Component {
  render() {
    const { member, index, fields } = this.props;
    const isHide =
      fields.length === 1 &&
      (fields.get(index).name === undefined || fields.get(index).name === '');

    return (
      <div className="mk-grouped-input">
        {!isHide && (
          <div className={`form-group col-md-6`}>
            <Field
              name={`${member}.name`}
              component={SettingField}
              className="form-control"
              placeholder="Name"
            />
          </div>
        )}
        <div
          className={`item-variant-sales-type-input-sku form-group ${
            isHide ? 'col-md-12' : 'col-md-6'
          }`}
        >
          <Field
            name={`${member}.sku`}
            component="input"
            className="form-control text-align-last-left"
            placeholder="SKU"
          />
        </div>
      </div>
    );
  }
}

export default ItemVariantSalesTypesFields;
